import { createRouter } from "@tanstack/react-router";
import { DebugProvider } from "@/context/DebugContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { VariantProvider } from "@/context/VariantContext";
import { ViewerProvider } from "@/context/ViewerContext";
import { routeTree } from "@/routeTree.gen";

// Central router instance so devtools and the app share the exact same reference.
export const router = createRouter({
  routeTree,
  Wrap: ({ children }) => (
    <DebugProvider>
      <VariantProvider>
        <ThemeProvider>
          <ViewerProvider>{children}</ViewerProvider>
        </ThemeProvider>
      </VariantProvider>
    </DebugProvider>
  ),
});

// Extend the TanStack Router module declaration for full type safety.
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export type AppRouter = typeof router;
